const categoriesChapter = [
  {
    target: '[data-tour="categories-section"]',
    content: 'This is the Categories section. You can manage all your recipe categories here.',
    placement: 'right',
  },
  {
    target: '[data-tour="add-category-button"]',
    content: 'Click this button to add a new category.',
    placement: 'right',
  },
  {
    target: '[data-tour="add-category-button"]',
    content: "Let's see how it works. The modal for adding a new category will open now.",
    placement: 'right',
    onNext: (helpers) => helpers.openAddCategoryModal(),
  },
  {
    target: '.modal-content input[type="text"]',
    content: 'You can type the name of your new category here.',
    placement: 'bottom',
  },
  {
    target: '.modal-footer button:first-of-type',
    content: "Then you can save it. For this tour, we'll just close the modal.",
    placement: 'top',
    onNext: (helpers) => helpers.closeAddCategoryModal(),
  },
  {
    target: '[data-tour="categories-section"]',
    content: 'Click the header to expand the section and see your categories.',
    placement: 'right',
    onLoad: (helpers) => helpers.expandCategories(),
  },
  {
    target: '[data-tour="categories-search"]',
    content: 'Once expanded, you can search for specific categories here.',
    placement: 'right',
  },
  {
    target: '[data-tour="categories-list"]',
    content: 'Your categories will be listed here. We have added a temporary one for this tour.',
    placement: 'right',
  },
  {
    target: '[data-tour="category-temp-cat-1"]',
    content: 'Here is the temporary category. It will be removed when the tour ends.',
    placement: 'right',
  },
  {
    target: '[data-tour="category-temp-cat-1"] .delete-button',
    content: 'Deleting any item in the application will prompt a confirmation modal to prevent accidental data loss.',
    placement: 'right',
  },
  {
    target: '[data-tour="categories-section"]',
    content: "Let's close this section to continue.",
    placement: 'right',
    onNext: (helpers) => helpers.collapseCategories(),
  },
];

const cookbooksChapter = [
  {
    target: '[data-tour="cookbooks-section"]',
    content: 'This is the Cookbooks section, where you can organize your recipes into different books.',
    placement: 'right',
  },
  {
    target: '[data-tour="add-cookbook-button"]',
    content: "Click here to add a new cookbook. Let's open the cookbook modal.",
    placement: 'right',
    onNext: (helpers) => helpers.openAddCookbookModal(),
  },
  {
    target: '.modal-content input[type="text"]',
    content: 'In this modal, you can enter the title for your new cookbook.',
    placement: 'bottom',
  },
  {
    target: '.modal-footer',
    content: 'You can then save it. We will close it for now.',
    placement: 'top',
    onNext: (helpers) => helpers.closeAddCookbookModal(),
  },
  {
    target: '[data-tour="cookbooks-section"]',
    content: 'Expand the section to see your cookbooks.',
    placement: 'right',
    onLoad: (helpers) => helpers.expandCookbooks(),
  },
  {
    target: '[data-tour="cookbooks-search"]',
    content: 'You can search for cookbooks by title.',
    placement: 'right',
  },
  {
    target: '[data-tour="cookbooks-list"]',
    content: 'Your cookbooks are listed here. Click to filter recipes by cookbook.',
    placement: 'right',
  },
  {
    target: '[data-tour="cookbooks-section"]',
    content: "Now, let's close this section.",
    placement: 'right',
    onNext: (helpers) => helpers.collapseCookbooks(),
  },
];

const ingredientsChapter = [
  {
    target: '[data-tour="ingredients-section"]',
    content: 'Here you can manage your master list of all ingredients.',
    placement: 'right',
  },
  {
    target: '[data-tour="add-ingredient-button"]',
    content: "Add a new ingredient to your master list. Let's see the modal.",
    placement: 'right',
    onNext: (helpers) => helpers.openAddIngredientModal(),
  },
  {
    target: '.modal-content input[type="text"]',
    content: 'Simply type the name of the ingredient and save it.',
    placement: 'bottom',
  },
  {
    target: '.modal-footer',
    content: 'For now, we will just close this modal.',
    placement: 'top',
    onNext: (helpers) => helpers.closeAddIngredientModal(),
  },
  {
    target: '[data-tour="ingredients-section"]',
    content: 'Expand to see the full list.',
    placement: 'right',
    onLoad: (helpers) => helpers.expandIngredients(),
  },
  {
    target: '[data-tour="ingredients-list"]',
    content: 'This is your master list of ingredients.',
    placement: 'right',
  },
  {
    target: '[data-tour="ingredients-section"]',
    content: "Let's close this ingredients list.",
    placement: 'right',
    onNext: (helpers) => helpers.collapseIngredients(),
  },
];

const recipesChapter = [
  {
    target: '[data-tour="recipes-section"]',
    content: 'This is the main Recipes section. All your recipes are listed here.',
    placement: 'right',
  },
  {
    target: '[data-tour="add-recipe-button"]',
    content: 'Click here to add a new recipe. This opens a detailed modal.',
    placement: 'right',
    onNext: (helpers) => helpers.openAddRecipeModal(),
  },
  {
    target: '[data-tour="recipe-modal-name"]',
    content: 'First, give your recipe a name.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="recipe-modal-cookbook"]',
    content: 'You can assign it to a cookbook and add a page number. You can even create a new cookbook from here by typing a new name and hitting Enter.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="recipe-modal-categories"]',
    content: 'Assign one or more categories. Just like cookbooks, you can create new categories on the fly.',
    placement: 'bottom',
  },
  {
    target: '[data-tour="recipe-modal-ingredients"]',
    content: "Add all the ingredients for your recipe. If an ingredient doesn't exist in your master list, it will be added automatically.",
    placement: 'top',
  },
  {
    target: '[data-tour="recipe-modal-save-close"]',
    content: "Once you are done, you can save the recipe. Let's close this for now.",
    placement: 'top',
    onNext: (helpers) => helpers.closeAddRecipeModal(),
  },
  {
    target: '[data-tour="recipe-temp-recipe-1"]',
    content: 'For this tour, we have added a temporary recipe. Click on it to add it to the meal plan on the right.',
    placement: 'right',
  },
  {
    target: '[data-tour="recipe-filter-button"]',
    content: "Use this to open a detailed filter for your recipes. Let's check it out.",
    placement: 'right',
    onNext: (helpers) => helpers.openFilterModal(),
  },
  {
    target: '.modal-content .filter-container',
    content: 'The filter modal allows you to find recipes by combining filters for cookbooks, categories, and ingredients.',
    placement: 'bottom'
  },
  {
    target: '.modal-content .modal-footer button:first-of-type',
    content: "Once you are happy with the selected filters, you can click Apply. Let's close this for now.",
    placement: 'top',
    onNext: (helpers) => helpers.closeFilterModal(),
  },
];

const mealPlanChapter = [
  {
    target: '[data-tour="meal-plan-panel"]',
    content: 'Your selected recipes appear here, forming your meal plan. For the tour, we have selected the temporary recipe for you.',
    placement: 'left',
  },
  {
    target: '[data-tour="meal-plan-days"]',
    content: 'You can change the number of days for your meal plan here.',
    placement: 'left',
  },
  {
    target: '[data-tour="meal-plan-servings"]',
    content: 'Adjust the global serving size for all recipes in the plan.',
    placement: 'left',
  },
  {
    target: '[data-tour="day-slot-1"]',
    content: 'Drag and drop recipes into specific day slots to organize your plan.',
    placement: 'left',
  },
  {
    target: '[data-tour="meal-plan-save-button"]',
    content: "When you are done, you can save your meal plan. For a new plan, a modal will ask for a name. For existing plans, you can save changes or use 'Copy' to save as a new plan.",
    placement: 'left',
  },
  {
    target: '.meal-plan-title-container',
    content: 'Once a meal plan is saved and loaded, an edit icon will appear here, allowing you to rename it via the Edit Meal Plan modal.',
    placement: 'left',
  },
];

const shoppingListChapter = [
  {
    target: '[data-tour="meal-plan-ingredients-list"]',
    content: 'All ingredients for the current meal plan are listed here. We have added a few for this demo.',
    placement: 'left',
    delay: 500, // Add a 500ms delay
  },
  {
    target: '[data-tour="select-all-ingredients-button"]',
    content: 'You can click here to add all ingredients to your shopping list at once.',
    placement: 'left',
    onNext: (helpers) => helpers.selectAllIngredients(),
  },
  {
    target: '[data-tour="shopping-list-panel"]',
    content: 'The shopping list now shows all the ingredients you need to buy. Click an item to remove it.',
    placement: 'left',
  },
  {
    target: '[data-tour="shopping-list-print-button"]',
    content: 'You can print your shopping list from here.',
    placement: 'left',
  },
];

export const tourChapters = {
  'Categories': categoriesChapter,
  'Cookbooks': cookbooksChapter,
  'Ingredients': ingredientsChapter,
  'Recipes': recipesChapter,
  'Meal Plan': mealPlanChapter,
  'Shopping List': shoppingListChapter,
};
